<h1 mat-dialog-title>Save Draft</h1>
<mat-dialog-content>
  <h3>Do you want to save changes?</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-flat-button mat-dialog-close>Cancel</button>
    <button
      mat-raised-button
      class="ms-2"
      color="primary"
      (click)="onDiscard()"
    >
      Discard
    </button>
    <button mat-raised-button class="ms-2" color="primary" (click)="onSave()">
      Save
    </button>
  </div>
</mat-dialog-actions>
